enum TaxiDriverAssociationContractType {
  B2B = "B2B",
  EMPLOYMENT = "EMPLOYMENT",
  CONTRACT_OF_MANDATE = "CONTRACT_OF_MANDATE",
}

export default TaxiDriverAssociationContractType;
